import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { ReactElement } from "react";

import { useIntl } from "./IntlProvider";

export const DateLocalizationProvider = ({
  children,
}: {
  children: ReactElement;
}): ReactElement => {
  const intl = useIntl();
  return (
    <LocalizationProvider
      dateAdapter={AdapterLuxon}
      adapterLocale={intl.locale}
    >
      {children}
    </LocalizationProvider>
  );
};
